<template>
  <div id="Tree" :style="{height:max+'px'}">
    <div class="tree_top">
        <div class="tree_title">全部分类</div>
        <div class="el-icon-d-arrow-left title_right_btn"></div>
    </div>
    <el-tree
        node-key="id"
        ref="tree"
        :data="treeData"
        :props="defaultProps"
        :highlight-current="true"
        icon-class="iconfont icon-file-close"
        @node-click="handleNodeClick"
    ></el-tree>
  </div>
</template>

<script>

export default {
  name: "Tree",
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      };
    },
    methods: {
      handleNodeClick(data) {
          this.$emit('clickTree',data);
          // console.log(data);
      },
      // 设置树控件第几个选中
      setTreeNode(){
          // const store = this.$refs.tree.store;
          // const node = store.getNode(key);
          // store.setCurrentNode(node);
          // this.$refs.tree.currentNode = node;
          // store.setCurrentNodeKey(key);
          // store.currentNodeKey = key;
          this.$refs.tree.setCurrentKey(0);
      },
    },
    props: {
        treeData:Array,
        //控件的高度
        max:{
          type:String,
          default:'300'
        },
    }
};
</script>
<style lang="less">
#Tree {
    // height: 300px;
    width: 100%;
    overflow: scroll;
    border: 1px solid #e7e7e7;
    .tree_top{
        width: 100%;
        height: 36px;
        box-sizing: border-box;
        padding: 0 8px;
        display: -webkit-box !important;
        display: box !important;
        position:relative;
        -webkit-box-align:center;
        box-align:center;
        -webkit-box-pack:justify;
        box-pack:justify;
        background: #f1f1f1;
        border-bottom: 1px solid #e7e7e7;
        .tree_title{
            position:relative;
            -webkit-box-flex: 1; 
            box-flex: 1;
        }
        .title_right_btn{
            height: 36px;
            line-height: 36px;
            width: 20px;
            font-size: 18px;
        }
    }
    .el-tree-node__expand-icon{
        font-size: 20px;
    }
    .el-tree-node__expand-icon.expanded {
        -webkit-transform: rotate(0deg) !important;
        transform: rotate(0deg) !important;
    }
    .el-tree-node__expand-icon.expanded::before{
        content:"\e62e";
        font-size: 22px;
    }
}
#Tree::-webkit-scrollbar{
     display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/Tree/Tree.vue